import { Text, HStack, Grid, GridItem, Center, VStack } from "@reverb-ui/react";
import { TDaysParting } from "domain/entities/day-parting-response";

import { Fragment, useMemo } from "react";
import { DayPartingFooterTable } from "./DayPartingFooterTable";
import { HourSideTable } from "./HourSideTable";
import { ResultCell } from "./ResultCell";

export type MetricType = "Respondents" | "Conversion";

export type DaysPartingTableProps = {
  daysPartingData: TDaysParting;
  metric: MetricType;
};

export const DayPartingTable = ({
  daysPartingData,
  metric,
}: DaysPartingTableProps) => {
  const daysPartingList = useMemo(
    () =>
      Object.values(daysPartingData).map((dayParting) =>
        Object.values(dayParting)
      ),
    [daysPartingData]
  );

  const daysOfWeek = useMemo(
    () => Object.keys(daysPartingData),
    [daysPartingData]
  );

  const totalProp = metric === "Respondents" ? "total" : "totalConverted";
  const percentageProp =
    metric === "Respondents" ? "percentage" : "percentageConversion";

  return (
    <Grid templateColumns="4.43rem repeat(7,1fr)" templateRows="repeat(25,1fr)">
      <HourSideTable />
      <GridItem rowSpan={24} colSpan={7} marginBottom="1">
        <HStack width="full" justifyContent="space-between" spacing="2px">
          {daysPartingList.map((day, index) => (
            <VStack flex={1} width="full" spacing="2px" key={index}>
              {day.map((hour, index) => (
                <Fragment key={index}>
                  <ResultCell percentage={hour[percentageProp]}>
                    {hour[totalProp]} {hour[percentageProp]}
                  </ResultCell>
                </Fragment>
              ))}
            </VStack>
          ))}
        </HStack>
      </GridItem>
      <DayPartingFooterTable>
        {daysOfWeek.map((day, index) => (
          <Center flex={1} key={index}>
            <Text fontSize="xs" color="gray.500" fontWeight="semibold">
              {day.toUpperCase()}
            </Text>
          </Center>
        ))}
      </DayPartingFooterTable>
    </Grid>
  );
};
